import { AlertTriangle, RotateCcw } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { ApiError } from '@/api/http-errors';
import { openSupportDetails } from '@/lib/error-support';

export function ErrorState({
  onRetry,
  message = 'Não foi possível carregar estes dados.',
  error,
}: {
  onRetry?: () => void;
  message?: string;
  error?: unknown;
}) {
  return (
    <div
      className="flex min-h-64 flex-col items-center justify-center px-6 py-12 text-center"
      role="alert"
    >
      <div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300">
        <AlertTriangle className="size-5" />
      </div>
      <h3 className="font-semibold">Algo saiu do previsto</h3>
      <p className="mt-1 max-w-md break-words text-sm text-[rgb(var(--muted-foreground))]">
        {error instanceof ApiError ? error.message : message}
      </p>
      {error instanceof ApiError ? (
        <Button variant="ghost" size="sm" onClick={openSupportDetails}>
          Ver orientação e copiar detalhes
        </Button>
      ) : null}
      {onRetry ? (
        <Button variant="outline" size="sm" className="mt-5" onClick={onRetry}>
          <RotateCcw /> Tentar novamente
        </Button>
      ) : null}
    </div>
  );
}
